import { Component, Input } from '@angular/core';
import { NavParams, Platform } from '@ionic/angular';

import { AuthService } from '../../service/auth.service';
import { EventService } from '../../service/event.service';

@Component({
    selector: 'app-sort-modal',
    templateUrl: './sort-modal.page.html',
    styleUrls: ['./sort-modal.page.scss'],
})
export class SortModalPage
{
    private hide = false;
    private type = "1";
    private sort_folder = 0;
    private order = null;
    private sort = null;

    private type_group = {
        file_name: {ASC: "1", DESC: "2"},
        file_mtime: {ASC: "3", DESC: "4"},
    };

    constructor(
        private navParams: NavParams,
        private platform: Platform,
        private auth: AuthService,
        private event: EventService
    )
    {
    }

    async ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: 'sort-modal', value: null});
        this.order = this.navParams.data.order;
        this.sort = this.navParams.data.sort;
        this.sort_folder = this.navParams.data.sort_folder;
        this.hide = this.navParams.data.hide;

        if (!this.auth.empty(this.order)) {
            this.type = this.type_group[this.order][this.sort];
        }
    }

    sortOnChangeToggle(event)
    {
        this.sort_folder = (event.target.checked ? 1 : 0);
        this.event.modal_subject.next({key: "closeModal", id: 'sort-modal', value: { order: this.order, sort: this.sort, sort_folder: this.sort_folder }});
    }

    setSort(type)
    {
        switch (type) {
            case "1":
                this.order = "file_name";
                this.sort = "ASC";
                break;
            case "2":
                this.order = "file_name";
                this.sort = "DESC";
                break;
            case "3":
                this.order = "file_mtime";
                this.sort = "ASC";
                break;
            case "4":
                this.order = "file_mtime";
                this.sort = "DESC";
                break;
            default:
                break;
        }

        this.event.modal_subject.next({key: "closeModal", id: 'sort-modal', value: { order: this.order, sort: this.sort, sort_folder: this.sort_folder }});
    }

    sortClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: 'sort-modal', value: null});
    }
}
